// src/utils/http-client.js
import axios from "axios"
import { getAuthToken, removeAuthToken } from "./token-util"
import {
  removeAuthToken as removeCreatorToken,
  getAuthToken as getCreatorToken,
} from "./creatorTokenUtil"

// hard-coded URLs instead of env vars:
const BASE_API = "https://blitz-app-u3rzf.ondigitalocean.app/api"
const ENGAGEMENT_API = "https://extract-data-delta.vercel.app/"

// create your axios instance
const Axios = axios.create({
  baseURL: BASE_API,
  timeout: 120_000,
  headers: {
    "Content-Type": "application/json",
  },
})

// add your interceptors
Axios.interceptors.request.use(
  (config) => {
    const token = getAuthToken() || getCreatorToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    // keep your localhost testing key logic if you still need it
    if (window.location.hostname === "localhost") {
      const testingKey = window.REACT_APP_TESTING_KEY   // or just drop this block
      if (testingKey) {
        config.headers["X-Testing-Key"] = testingKey
      }
    }

    // avoid bracketed arrays in query strings
    config.paramsSerializer = {
      indexes: null,
    }
    return config
  },
  (error) => Promise.reject(error)
)

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error
    if (
    response &&
    config.headers?.Authorization &&          // we actually *sent* a token
    !config.ignoreAuthError &&
    (response.status === 401 ||
     response.status === 403 ||
     (response.status === 422 && response.data?.error === "Invalid token"))
  ) {
      removeAuthToken()
      removeCreatorToken()
      window.location.reload()
    }
    if (config.accept404 && response.status === 404) {
      return { data: null }
    }
    return Promise.reject(error)
  }
)

export class HttpClient {
  static async get(url, params = null, config = {}) {
    const { data } = await Axios.get(url, { params, ...config })
    return data
  }

  static async post(url, body, config = {}) {
    const { data } = await Axios.post(url, body, config)
    return data
  }

  static async put(url, body, config = {}) {
    const { data } = await Axios.put(url, body, config)
    return data
  }

  static async delete(url, config = {}) {
    const { data } = await Axios.delete(url, config)
    return data
  }
}

export const ConfigValue = {
  // if you still need a PORT constant, otherwise you can remove this
  PORT: 3000,

  // now hard-coded:
  PUBLIC_REST_API_ENDPOINT: BASE_API,
  PUBLIC_ENGAGEMENT_API_ENDPOINT: ENGAGEMENT_API,

  AUTH_TOKEN_KEY: "blitz-auth-token",
  AUTH_USER_INFO: "blitz-auth-user",
  AUTH_CREATOR_TOKEN_KEY: "blitz-creator-token",
  AUTH_CREATOR_USER_INFO: "blitz-creator-auth-user",
}
